import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Services
import { RouteParam, ServiceBase } from '../service-base';

// Modèles
import { Journal } from 'src/app/@shared/models/accounting/journal.model';

const CLASS_NAME = 'Journal';
const ENDPOINT = `/journals/`;
const ROUTES: RouteParam[] = [
    { key: 'massDelete', path: 'mass-delete/' },
    { key: 'merge', path: '{id}/merge/' }
]

@Injectable({
    providedIn: 'root'
})
export class JournalService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addRoutes(ROUTES);
    }

    public merge$(sourceJournal: Journal, targetJournal: Journal): Observable<any> {
        return this.update$(sourceJournal, {
            select: false,
            url: this.routes.merge.replace('{id}', targetJournal.id.toString())
        });
    }
}
